import React from 'react'
import { Helmet } from 'react-helmet-async';
import Header from '../components/DiplomadosDisponibles/Header';
import Diplomas from '../components/DiplomadosDisponibles/Diplomados';
import CallToAction from '../components/DiplomadosDisponibles/CallToAction';

const About = () => {
  return (
    <>

      {/* SEO */}
      <Helmet>
        <title>Diplomado en Ultrasonografía Diagnóstica - IMDI Tuxtla</title>        
        <meta name="description" content="Capacítate en ultrasonografía diagnóstica con IMDI Tuxtla. Diplomados en ultrasonido, ecografía y doppler materno fetal con expertos médicos." />
        <meta name="keywords" content="diplomados en ultrasonografía, ultrasonido diagnóstico, ecografía médica, doppler materno fetal, maestría en ultrasonografía" />
        <meta name="author" content="IMDI Tuxtla" />
        <link rel="canonical" href="https://imdituxtla.com.mx/about" />
      </Helmet>

    <Header />
    <Diplomas />
    <CallToAction />
    </>
  )
}

export default About